export default __webpack_public_path__ + "static/media/add_icon.fa7730f0.svg";